import React, { useContext } from 'react'
import { AppContext, useGlobalContext } from './context'
import context from './context';
import { NavLink } from 'react-router-dom';

const Movies = () => {
  const imgUrl = "https://via.placeholder.com/200/200";
  
  const { movie, isLoading } = useGlobalContext();
  if (isLoading) {
    return <div className="loading">Loading....</div>;
  }
  return (
    
    <section className='movie-page'>
      <div className='grid grid-4-col'>
      {
        movie?
        movie.map((curr)=>{
          const{imdbID,Title,Poster}=curr;
          const movieName=Title.substring(0,19);
        

          return <div>
          <NavLink to={`movie/${imdbID}`} >
            <div className='card'>
              <div className='card-info'>
                <h2>{
                    Title.lenght > 15? `${movieName}...`:movieName
                  }</h2>
                <img src={Poster === "N/A" ? imgUrl : Poster} alt="#" />
              </div>
            </div>

          </NavLink>
          </div>
        })
        :""
      }
      </div>
    </section>
      
    
  )
  
}

export default Movies
